import { IProperty } from "@kuika/kuika-cl-model";
import React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import { PropertyFormItem } from "../../../right-panel/properties-panel/property-form-item";
import { ResponsiveDesignToolkit } from "../../../right-panel/properties-panel/responsive-design-toolkit";
import { IQuickContext, openPropertiesPanel } from "./quick-shared";

export interface IQuickEditorBodyProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * The body of an editor popover: the property panel's own editor under a title, with Done. The full
 * panel is always open beside the canvas, so there is no separate way into it from here. The popover
 * is the overlay's own surface, like every bar popover; that surface is the designer's themed popover
 * ground, which the reused editors are built for.
 */
export const QuickEditorBody = ({ title, onClose, children }: IQuickEditorBodyProps): JSX.Element => (
  <>
    <div className="kuika-quick-editor__title">{title}</div>
    {children}
    <div className="kuika-quick-editor__footer">
      <KuikaButton type="primary" size="sm" data-testid="quickPropEditorDone" onClick={onClose}>
        Done
      </KuikaButton>
    </div>
  </>
);

export interface IQuickPropertyEditorProps {
  ctx: IQuickContext;
  property: IProperty;
}

/**
 * `PropertyFormItem` — the property panel's row editor — for one property: datasource, options, image,
 * icon, colour, bindings… all reused as they are, never re-implemented here. Its JSON editor lives in
 * the panel's `PropertyForm`, so asking for it opens the panel instead.
 */
export const QuickPropertyEditor = ({ ctx, property }: IQuickPropertyEditorProps): JSX.Element => (
  <PropertyFormItem
    kuikaId={ctx.kuikaId}
    property={property}
    toggleJsonModal={(): void => openPropertiesPanel(ctx.sd)}
  />
);

/** A Col's widths are edited through its row, the way the panel's responsive toolkit does it. */
export const QuickColumnEditor = (): JSX.Element => <ResponsiveDesignToolkit />;
